import { FC } from 'react';

import { EmptyProps } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledEmpty from './styles';

type NotFoundContentProps = EmptyProps & {
  cta?: React.ReactNode;
};

const nfImage =
  'https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg';

const RNotFoundContent: FC<NotFoundContentProps> = ({
  description,
  cta,
  image = nfImage,
  imageStyle = { height: 60 },
  styles: stylesProp,
  ...props
}) => {
  const { t } = useTranslation();

  const defaultDescription = t('components.notFoundContent.defaultDescription');
  return (
    <StyledEmpty
      style={{ padding: '12px' }}
      image={image}
      styles={{ ...stylesProp, image: imageStyle }}
      description={description || defaultDescription}
      {...props}
    >
      {cta}
    </StyledEmpty>
  );
};

export default RNotFoundContent;
